import script from "./HeaderLogo.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderLogo.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__